import { render, staticRenderFns } from "./MiniappshaichaWxuser.vue?vue&type=template&id=ec4a0acc&scoped=true&"
import script from "./MiniappshaichaWxuser.vue?vue&type=script&lang=js&"
export * from "./MiniappshaichaWxuser.vue?vue&type=script&lang=js&"
import style0 from "./MiniappshaichaWxuser.vue?vue&type=style&index=0&id=ec4a0acc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4a0acc",
  null
  
)

export default component.exports